import { FunctionComponent, ReactElement, useMemo } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import ChangePassword from '../components/ChangePassword';

const SetNewPassword: FunctionComponent = (): ReactElement => {
	const [queryParams] = useSearchParams();
	const token = useMemo(() => queryParams.get('token'), [queryParams]);

	if (!token) {
		return <Navigate to="/auth/login" replace={true} />;
	}

	return <ChangePassword type="create" token={token} navigateAfterSuccess="/auth/login" />;
};

export default SetNewPassword;
